import declare from "dojo/_base/declare";
import BooleanRen from "csi/heading/Boolean";

const Active3DEnvironmentRenderer = declare(BooleanRen, {

	/**
	 * @override
	 * Disable
	 */
	_getRenderAction: function(ctx, h) {
		const node = ctx.getNode();
		return node.Default ? null : this.inherited(arguments);
	},
});

export = Active3DEnvironmentRenderer;
